<template>
  <div class="custom-dialog">
    <custom-modal :active="promptStatus"
                  :fixed-height="false"
                  @close="handleCloseDialog">
      <template #header>
        <div class="prompt-header p-3 w-full" :class="[!$vs.rtl ? 'rtl-only' : '']">
          <vs-row>
            <vs-spacer/>

            <vs-col class="w-1/2 text-center useral-font-weight-bold text-md">
              {{title}}
            </vs-col>

            <vs-spacer/>
          </vs-row>
        </div>
      </template>
      <template #content>
        <div class="prompt-content py-2 px-3">
          <slot>
            <vs-col class="custom-dialog-body my-5">
              <slot name="body">
              <span v-html="body">
  <!--            {{ body }}-->
              </span>
              </slot>
            </vs-col>
          </slot>

          <!--<vs-divider v-if="showButtons"
                      class="my-3"/>-->

          <vs-col v-if="showButtons">
            <vs-col v-if="hasCancel" class="w-1/2 text-right useral-font-weight-medium text-danger cursor-pointer" :class="$vs.rtl ? 'pl-1' : 'pr-1'">
              <vs-button class="w-full"
                         type="border"
                         color="rgb(153,153,153)"
                         @click="$emit('close'), promptStatus = false">
                {{ $t('customDialog.cancel') }}
              </vs-button>
            </vs-col>

            <vs-col class="useral-font-weight-medium text-success cursor-pointer" :class="[$vs.rtl ? 'pr-1' : 'pl-1', {'w-1/2': hasCancel}]">
              <vs-button class="w-full"
                         :color="accessColor"
                         @click="$emit('accept'), promptStatus = false">
                {{ $t('customDialog.confirm') }}
              </vs-button>
            </vs-col>
          </vs-col>
        </div>
      </template>
    </custom-modal>
  </div>
</template>

<script>
import CustomModal from "@/components/modal/customModal.vue";

export default {
  name: 'customDialog',
  components: {CustomModal},
  props: {
    title: {
      type: String,
      default: ''
    },
    body: {
      type: String,
      default: ''
    },
    closed: {
      type: Boolean,
      default: true
    },
    showButtons: {
      type: Boolean,
      default: true
    },
    hasCancel: {
      type: Boolean,
      default: true
    },
    accessColor: {
      type: String,
      default: 'danger',
      validator (value) {
        return ['success', 'danger', 'warning', 'dark', 'primary'].includes(value)
      }
    }
  },
  data () {
    return {
      promptStatus: false
    }
  },
  methods: {
    showDialog () {
      this.promptStatus = true
    },
    handleCloseDialog () {
      if (this.closed) {
        this.$emit('close')
        this.promptStatus = false
      } else {
        this.promptStatus = true
      }
    }
  }
}
</script>

<style lang="scss">
.custom-dialog-body {
  text-align: justify;
}
</style>
